import {
  GET_ET_DATES,
  GET_ET_MONTHLY_DATES,
  GET_ET_FORTNIGHTLY_DATES,

  SET_MN_SELECTED_LAYER,
  SET_FN_SELECTED_LAYER,
  

  GET_ET_ERROR,
  ON_SLIDE,
  SELECTED_MENU,
  SELECTED_LAYER,
  ON_SLIDE_LEFT,
  ON_SLIDE_RIGHT,
  HANDLE_DATE_CHANGE,
  ON_MAP_CLICK,
  FETCH_REQUEST,
  TOGGLE_VISIBLE_GRAPH,
  TOGGLE_SELECTED_NODE_STATUS,
  SIDEBAR_TOGGLE,
  SET_LEGEND,
  TECHNICAL_NOTE_TOGGLE,
  DISCLAIMER_TOGGLE,
  EB_POPUP,
  WB_POPUP,
  DIALOG_TOGGLE,
  SET_SHOWINFO,
  WIDTH_UPDATE,
  INLINE_MODE_CHANGE,
} from "../types";
import domain from "../../domain";
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import file_heads from "../../web_et/Helpers/file-heads";

const units = {
  yAxis: {
    Evapotranspiration: "mm/day",
    Evapotranspiration_WB: "mm/day",
  },
};


export const setSelectedMNLayer = (date,product) => (dispatch) => {

  //console.log(date,product,"menumenu date,month, productttttttttttttttttttttt")

  dispatch({
    type: SET_MN_SELECTED_LAYER,
    layername: `${product}_SNPP_N_EB_MN_${date}`,
  });
};

export const setSelectedFNLayer = (date, fortnight,product) => (dispatch, getState) => {
  
  //console.log(date, fortnight,product,"menumenu date, fortnight,product")

  dispatch({
    type: SET_FN_SELECTED_LAYER,
    layername: `${product}_SNPP_N_EB_${fortnight}_${date}`,
  });
};

export const getWidth=()=>async (dispatch)=>{
  let w=window.innerWidth
  if(w<1027)
  {
    dispatch({
      type:WIDTH_UPDATE,
      width:w
    })
  }
}

export const getETDates = (menu) => async (dispatch) => {
  //console.log(menu,"menumenu")
  try {
    let result = await axios({
      method: "post",
      url: `${domain.DBServer}/get-avail-dates-${menu}`,
      data: {
        // selected: "Evapotranspiration"
      },
    });

    // let result_monthly = await axios({
    //   method: "post",]
    //   url: `${domain.DBServer}/get-avail-dates-et-Evapotranspiration-Monthly`,
    //   data: {
    //     // selected: "Evapotranspiration"
    //   },
    // });

    // let result_fortnightly = await axios({
    //   method: "post",
    //   url: `${domain.DBServer}/get-avail-dates-et-Evapotranspiration-Fortnightly`,
    //   data: {
    //     // selected: "Evapotranspiration"
    //   },
    // });

    const month_yrs = new Set()
    const fortnight_yrs = new Set()

    if(menu === "et-Evapotranspiration" || menu === "pet-Evapotranspiration" || menu === "mai-Evapotranspiration" ||menu === "esi-Evapotranspiration") {
      const availableDates = result.data.map((item) => {
        // let regex =/[0-9]*/gm
        var regex = /[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]/gi;
        let date = item.filename.match(regex)[0];
        // //console.log(date)
        // availableDates.push(moment(date))
        return moment(date);
      });
      //    //console.log(ad)
  
      // let maxdate = moment.max(availableDates).format("DD-MM-YYYY")
      let maxdate = "null"
      maxdate = moment.max(availableDates);
      ////console.log(maxdate);
      ////console.log("date from et module",maxdate)

      let sortedDates = _.sortBy(availableDates, (d) => {
        // ////console.log(d)
        return new moment(d);
      });
  
      dispatch({
        type: GET_ET_DATES,
        payload: sortedDates,
        date: maxdate,
        slideTracker: sortedDates.length - 1,
      });
    }

    if (menu === "et-Evapotranspiration-Monthly750"|| menu === "pet-Evapotranspiration-Monthly750"||menu === "mai-Evapotranspiration-Monthly750"||menu === "esi-Evapotranspiration-Monthly750") {
      const availableDates_monthly = result.data.map((item) => {
        // //console.log(item);
        var regex = /[0-9][0-9][0-9][0-9][0-9][0-9]/gi;
        let date = item.filename.match(regex)[0];
        month_yrs.add(moment(date).format('YYYY'));
        // //console.log('Date: '+ date +' Year: '+  + ' Month: ' + moment(date).format('MMMM'));
        return {
          "layerdate" : date,
          "year" : moment(date).format('YYYY'),
          "month" : moment(date).format('MMMM')
        };
      });

      dispatch({
        type: GET_ET_MONTHLY_DATES,
        payload: availableDates_monthly,
        years: Array.from(month_yrs),
        selectedYear: "",
        selectedMonth: "",
      });

      
    }

    if (menu === "et-Evapotranspiration-Fortnightly750"||menu === "pet-Evapotranspiration-Fortnightly750"||menu === "mai-Evapotranspiration-Fortnightly750"||menu === "esi-Evapotranspiration-Fortnightly750") {
      
      //console.log("Etactionssssssssssssssmenu",menu)

      const availableDates_fortnightly = result.data.map((item) => {
        // console.log(item);
        var regex1 = /FN[0-9]/gi;
        let fortn = item.filename.match(regex1)[0];
        var regex = /[0-9][0-9][0-9][0-9][0-9][0-9]/gi;
        let date = item.filename.match(regex)[0];
        fortnight_yrs.add(moment(date).format('YYYY'));
        // console.log('Fornt: '+ fortn +' Date: '+ date +' Year: '+ moment(date).format('YYYY') + ' Month: ' + moment(date).format('MMMM'));
        return {
          "layerdate" : date,
          "year" : moment(date).format('YYYY'),
          "month" : moment(date).format('MMMM'),
          "fortnight" : fortn,
        };
      });
      //console.log("Etactionssssssssssssss",menu,availableDates_fortnightly)

      dispatch({
        type: GET_ET_FORTNIGHTLY_DATES,
        payload: availableDates_fortnightly,
        years: Array.from(fortnight_yrs),
        selectedYear: "",
        selectedMonth: "",
        selectedFN: "",
      });


    }

  } catch (e) {
    dispatch({
      type: GET_ET_ERROR,
      payload: console.log(e),
    });
  }
};

export const toggleSelectedNodeStatus = (menu) => (dispatch, getState) => {
  let selectedNodeStatus = { ...getState().ETState.selectedMenu };

  selectedNodeStatus[menu] = !selectedNodeStatus[menu];
  //console.log("selected toggleSelectedNodeStatus",selectedNodeStatus, selectedNodeStatus[menu] )

  dispatch({
    type: TOGGLE_SELECTED_NODE_STATUS,
    selectedNodeStatus: selectedNodeStatus,
  });
};

export const setSelectedMenu = (menu) => (dispatch, getState) => {
  //console.log("menuuuuuuuuuuuuuuuuuuuuuuuuuuuuu",menu)
  dispatch(getETDates(menu));
  dispatch({
    type: SELECTED_MENU,
    payload: menu,
  });
};

export const setSelectedLayer = (main) => (dispatch, getState) => {
  let selectedLayer = { ...getState().ETState.selectedLayer };
  //console.log("selected layer from etactions setselectedlayer vbefore",selectedLayer)


  selectedLayer[main] = moment.isMoment(getState().ETState.date)
    ? file_heads[main] + getState().ETState.date.format("YYYYMMDD")
    : file_heads[main] +
    moment(getState().ETState.date, "DD-MM-YYYY").format("YYYYMMDD");
//console.log("selected layer from etactions setselectedlayer",selectedLayer)
  dispatch({
    type: SELECTED_LAYER,
    payload: selectedLayer,
  });
};

export const mn_YearChange = (value) => (dispatch, getState) => {


};

export const onSlide = (event) => (dispatch, getState) => {
  let value = parseInt(event.target.value, 10);

  let selected_date = moment(
    getState().ETState.dates[value],
    "DD-MM-YYYY"
  ).format("YYYYMMDD");
  let selectedLayer = { ...getState().ETState.selectedLayer };

  let menu = getState().ETState.selectedMenu;

  selectedLayer[menu] = file_heads[menu] + selected_date;

  dispatch({
    type: ON_SLIDE,
    payload: value,
    selectedLayer: selectedLayer,
  });
};

export const onClickSlideLeft = (event) => (dispatch, getState) => {
  let slideTracker = getState().ETState.slideTracker;
  if (slideTracker > 0) {
    slideTracker = slideTracker - 1;
  }

  let selected_date = moment(
    getState().ETState.dates[slideTracker],
    "DD-MM-YYYY"
  ).format("YYYYMMDD");
  let selectedLayer = { ...getState().ETState.selectedLayer };

  let menu = getState().ETState.selectedMenu;

  selectedLayer[menu] = file_heads[menu] + selected_date;
  // })
  dispatch({
    type: ON_SLIDE_LEFT,
    payload: slideTracker,
    date: getState().ETState.dates[slideTracker],
    selectedLayer: selectedLayer,
  });
};

export const onClickSlideRight = (event) => (dispatch, getState) => {
  let slideTracker = getState().ETState.slideTracker;
  if (slideTracker < getState().ETState.dates.length - 1) {
    slideTracker = slideTracker + 1;
  }

  let selected_date = moment(
    getState().ETState.dates[slideTracker],
    "DD-MM-YYYY"
  ).format("YYYYMMDD");
  let selectedLayer = { ...getState().ETState.selectedLayer };
  let menu = getState().ETState.selectedMenu;
  // Object.keys(file_heads).forEach((menu)=>{
  selectedLayer[menu] = file_heads[menu] + selected_date;
  // })

  dispatch({
    type: ON_SLIDE_RIGHT,
    payload: slideTracker,
    date: getState().ETState.dates[slideTracker],
    selectedLayer: selectedLayer,
  });
};

export const handleDateChange = (event, { name, value }) => (
  dispatch,
  getState
) => {
  let selected_date = moment(value, "DD-MM-YYYY").format("YYYYMMDD");
  let selectedLayer = { ...getState().ETState.selectedLayer };
  let availableDates = [...getState().ETState.dates];
  let availableDatesStr = availableDates.map((date) => {
    return moment(date, "DD-MM-YYYY").format("YYYYMMDD");
  });

  selectedLayer[getState().ETState.selectedMenu] =
    file_heads[getState().ETState.selectedMenu] + selected_date;
  dispatch({
    type: HANDLE_DATE_CHANGE,
    [name]: value,
    selectedLayer: selectedLayer,
    slideTracker: availableDatesStr.indexOf(selected_date),
  });
};

//  export const setLatLng()

export const toggleVisibleGraphPanel = () => (dispatch, getState) => {
  dispatch({
    type: TOGGLE_VISIBLE_GRAPH,
    visibleGraphPanel: !getState().ETState.visibleGraphPanel,
  });
};



export const technicalNodeToggle = () => (dispatch, getState) => {
  dispatch({
    type: TECHNICAL_NOTE_TOGGLE,
    payload: !getState().ETState.technicalnote,
  });
};

export const disclaimerToggle = () => (dispatch, getState) => {
  dispatch({
    type: DISCLAIMER_TOGGLE,
    payload: !getState().ETState.disclaimer,
  });
};
export const handleDialogClose = () => (dispatch, getState) => {
  dispatch({
    type: DIALOG_TOGGLE,
  });
};
export const modeChange = () => (dispatch, getState) => {
  dispatch({
    type: INLINE_MODE_CHANGE,
  });
};

export const EBPToggle = (name) => (dispatch, getState) => {
  if (name === "et-Evapotranspiration") {
    dispatch({
      type: EB_POPUP,
      payload: !getState().ETState.EB_Popup,
    });
  } else if (name === "Evapotranspiration_WB") {
    dispatch({
      type: WB_POPUP,
      payload: !getState().ETState.WB_Popup,
    });
  }
};

export const WBPToggle = () => (dispatch, getState) => {
  dispatch({
    type: WB_POPUP,
    payload: !getState().ETState.WB_Popup,
  });
};

export const sidebarToggle = () => (dispatch, getState) => {
  dispatch({
    type: SIDEBAR_TOGGLE,
    visible: !getState().ETState.visible,
  });
};

export const setLegend = (src) => (dispatch, getState) => {
  dispatch({
    type: SET_LEGEND,
    legend: src,
  });
};
export const showInfo_f = () => (dispatch, getState) => {
  dispatch({
    type: SET_SHOWINFO,
    payload: !getState().ETState.showInfo,
  });
};

export const onMapClick = (e) => async (dispatch, getState) => {

  if(getState().ETState.selectedMenu === "et-Evapotranspiration"   ||getState().ETState.selectedMenu ===  "pet-Evapotranspiration" || getState().ETState.selectedMenu === "mai-Evapotranspiration" ||getState().ETState.selectedMenu ===  "esi-Evapotranspiration" ) {
    let result = await axios({
      method: "post",
      url: `${domain.DBServer}/get-pixel-boundary-status`,
      data: {
        lon: e.latlng.lng,
        lat: e.latlng.lat
        // selected: this.state.selectedMenu
      }
    });
  
    if (result) {
      if(result.data[0].bounds)
      {
        dispatch({
          type: FETCH_REQUEST,
          visibleGraphPanel: true,
          loading: true,
          chartData: null,
          latlng: e.latlng,
        });
        if (e.latlng) {
          let chartData;
          try {
            let result = await axios({
              method: "post",
              url: `${domain.DBServer}/get-pixel-value-${
                getState().ETState.selectedMenu
                }`,
              data: {
                lon: e.latlng.lng,
                lat: e.latlng.lat,
                // selected: getState().ETState.selectedMenu
              },
            });
            let pointInfo = null,lat,long;
            let activeDate = moment.isMoment(getState().ETState.date)
              ? getState().ETState.date.format("YYYYMMDD")
              : moment(getState().ETState.date, "DD-MM-YYYY").format("YYYYMMDD");
            if (result) {
              if (result.data) {
                //console.log("result et fn ----------------selected",getState().ETState.selectedMenu,result.data)

                chartData = result.data.map((item) => {
                  
                    var regex = /[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]/gi;
                  
                      let date = item.filename.match(regex)[0];
                     // console.log("result date", date)
                                    if (activeDate === date) {
                                          pointInfo =
                                            item.pixel_val !== null
                                              ? item.pixel_val === 65535
                                                ? "No Data"
                                                : item.pixel_val === 65534
                                                  ? "Cloud"
                                                  : item.pixel_val.toFixed(3)
                                              : null;
                                    }
                                   
                      return [
                        new Date(
                          moment(item.filename.match(regex)[0]).format("D MMM YYYY")
                        ).getTime(),
                        item.pixel_val === 65535 || item.pixel_val === 65534
                          ? null
                          : Number(item.pixel_val).toFixed(3),
                      ];
                      //  }
                      // }else{
                      //     return([moment(chartDate).format("D MMM YYYY"),0.0])
                      // }
                    });

                    let chartdata=chartData.sort()
                    let chart_new=[];


                    let uniqueTimestamps = {};

                   
                   chartdata = chartdata.filter(item => {
                     
                      let timestamp = item[0];
                    
                     
                      if (!uniqueTimestamps[timestamp]) {
                        uniqueTimestamps[timestamp] = true;
                        return true;
                      }
                    
                      
                      return false;
                    });
                 
                

                    //console.log("result for et chart data after removing names ",chartData,chartdata);
                    var dates = chartData.map(function (x) {
                      return new Date(x[0]);
                    });
                    chartData.sort();
                    //console.log("result eeeeeeeeeeeeeetksdfajjjjjjfkkl",pointInfo,activeDate)
      
                    //let menu =getState().ETState.selectedMenu
                    let menu="Evapotranspiration"
                        //getState().ETState.selectedMenu === "et-Evapotranspiration"|| "pet-Evapotranspiration" || "mai-Evapotranspiration" || "esi-Evapotranspiration" ? "Evapotranspiration" : getState().ETState.selectedMenu === "Evapotranspiration_WB"
                        //  ? "Evapotranspiration (WB)"
                        //  : null;
                   
                  let title_pro;
                  //getState().ETState.selectedMenu.split("-")[0].toUpperCase()==="ET"?"AET": getState().ETState.selectedMenu.split("-")[0].toUpperCase()
                    let yaxistitle ;
                    if (getState().ETState.selectedMenu.split("-")[0].toUpperCase()==="ET" )
                    {
                      yaxistitle=`AET (mm/day)`
                      title_pro= "Actual Evapotranspiration"
                    }

                    if ( getState().ETState.selectedMenu.split("-")[0].toUpperCase()==="PET" ){
                      yaxistitle=`PET (mm/day)`
                      title_pro= "Potentional Evapotranspiration"
                    }
                    if (getState().ETState.selectedMenu.split("-")[0].toUpperCase()==="MAI" )
                    {
                      yaxistitle=`MAI (%)`
                      title_pro= "Moisture Adequacy Index"
                    }
                    if (getState().ETState.selectedMenu.split("-")[0].toUpperCase()==="ESI" )
                    {
                      yaxistitle=`ESI`
                      title_pro= "Evaporative Stress Index"
                    }


                    dispatch({
                      type: ON_MAP_CLICK,
                      chartData: {
                        seriesData: chartdata,
                        // categories:chartDates,
                        title: `Daily ${title_pro}`,
                        yAxisTitle: yaxistitle,
                        xAxisTitle:"Date",
                        // xAxisTitle:"Days",
                        long: e.latlng.lng,
                        lat: e.latlng.lat,
                        name: menu,
                        type: "line",
                        curve:"straight",
                        formatter:"dd MMM yyyy",
                        maximumDate: new Date(Math.max.apply(null, dates)),
                        minimumDate: new Date(Math.min.apply(null, dates)),
                      },
                      showInfo: true,
                      pointInfo: pointInfo,
                    });
                  }
            }
          } catch (e) {
            dispatch({
              type: GET_ET_ERROR,
              payload: console.log(e),
            });
          }
        }
      }
    }
    else
    {
      dispatch({
        type: TOGGLE_VISIBLE_GRAPH,
        visibleGraphPanel:false,
        latlng: e.latlng,
      });
    }

  }
  if(getState().ETState.selectedMenu ==="et-Evapotranspiration-Monthly750"|| getState().ETState.selectedMenu === "pet-Evapotranspiration-Monthly750"||getState().ETState.selectedMenu === "mai-Evapotranspiration-Monthly750"||getState().ETState.selectedMenu === "esi-Evapotranspiration-Monthly750"  ) {
    let result = await axios({
      method: "post",
      url: `${domain.DBServer}/get-pixel-boundary-status`,
      data: {
        lon: e.latlng.lng,
        lat: e.latlng.lat
        // selected: this.state.selectedMenu
      }
    });
  
    if (result) {
      if(result.data[0].bounds)
      {
        dispatch({
          type: FETCH_REQUEST,
          visibleGraphPanel: true,
          loading: true,
          chartData: null,
          latlng: e.latlng,
        });
        if (e.latlng) {
          let chartData;
          try {
            let result = await axios({
              method: "post",
              url: `${domain.DBServer}/get-pixel-value-${
                getState().ETState.selectedMenu
                }`,
              data: {
                lon: e.latlng.lng,
                lat: e.latlng.lat,
                // selected: getState().ETState.selectedMenu
              },
            });
            let pointInfo = null,lat,long;
            let activeDate = moment.isMoment(getState().ETState.date)
              ? getState().ETState.date.format("YYYYMMDD")
              : moment(getState().ETState.date, "DD-MM-YYYY").format("YYYYMMDD");
            if (result) {
              let count_num=1
              if (result.data) {

               let  chartData1 = result.data.map((item) => {
                  if(getState().ETState.selectedMenu === "et-Evapotranspiration-Monthly750" || getState().ETState.selectedMenu ===  "pet-Evapotranspiration-Monthly750"||getState().ETState.selectedMenu === "mai-Evapotranspiration-Monthly750"||getState().ETState.selectedMenu === "esi-Evapotranspiration-Monthly750") {

                      var regex = /[0-9][0-9][0-9][0-9][0-9][0-9]/gi;
                  }
                   
                    //let month_num= moment(item.filename.match(regex)[0], "YYYYMM").format("MM")
                    //console.log("evapotrans", month_num)
                    //if(month_num===month_num)
                    
       
                      return [
                        new Date(
                          moment(item.filename.match(regex)[0], "YYYYMM").format("MMM YYYY")
                        ).getTime(),
                        item.pixel_val === 65535 || item.pixel_val === 65534 ||item.pixel_val ===  null
                          ? null
                          : Number(item.pixel_val).toFixed(3),
                      ];
                      //  }
                      // }else{
                      //     return([moment(chartDate).format("D MMM YYYY"),0.0])
                      // }
                    });


                    let dates_all = chartData1.map(entry => moment(entry[0]));
                    let minDate = moment.min(dates_all);
                    let maxDate = moment.max(dates_all);
                    //console.log("evapotrans",minDate,maxDate)
                    const generateMonths = (startDate, endDate) => {
                      let start = moment(startDate);
                      let end = moment(endDate);
                      let months = [];
                    
                      while (start.isBefore(end) || start.isSame(end, 'month')) {
                        months.push(start.toDate().getTime());
                        start.add(1, 'month');
                      }
                    
                      return months;
                    };
                    
                    let allMonths = generateMonths(minDate, maxDate);
                    let dataDict = {};
                        chartData1.forEach(([date, value]) => {
                          dataDict[date] = value;
                        });

                        // Fill in the full month list with data or null for missing values
                        let chartData = allMonths.map(month => [
                          month,
                          dataDict[month] !== undefined ? dataDict[month] : "NA"
                        ]);


                    //console.log("result for et chart data after removing names ",chartData);
                    var dates = chartData1.map(function (x) {
                      return new Date(x[0]);
                    });
                    chartData.sort();
                    //console.log("result etksdfajjjjjjfkkl")
      
                    let menu =
                      getState().ETState.selectedMenu === "et-Evapotranspiration-Monthly750" || getState().ETState.selectedMenu ===  "pet-Evapotranspiration-Monthly750"||getState().ETState.selectedMenu === "mai-Evapotranspiration-Monthly750"||getState().ETState.selectedMenu === "esi-Evapotranspiration-Monthly750"?"Evapotranspiration-Monthly"
                        : getState().ETState.selectedMenu === "Evapotranspiration_WB"
                          ? "Evapotranspiration (WB)"
                          : null;
                    let title_pro=getState().ETState.selectedMenu.split("-")[0].toUpperCase()=="ET"?"AET": getState().ETState.selectedMenu.split("-")[0].toUpperCase()

                    let yaxistitle ;
                    if (getState().ETState.selectedMenu.split("-")[0].toUpperCase()==="ET" )
                    {
                      yaxistitle=`AET (mm/day)`
                      title_pro= "Monthly Actual Evapotranspiration"

                    }

                    if ( getState().ETState.selectedMenu.split("-")[0].toUpperCase()==="PET" ){
                      yaxistitle=`PET (mm/day)`
                      title_pro= "Monthly Potentional Evapotranspiration"

                    }
                    if (getState().ETState.selectedMenu.split("-")[0].toUpperCase()==="MAI" )
                    {
                      yaxistitle=`MAI (%)`
                      title_pro= "Monthly Moisture Adequacy Index"

                    }
                    if (getState().ETState.selectedMenu.split("-")[0].toUpperCase()==="ESI" )
                    {
                      yaxistitle=`ESI`
                      title_pro= "Monthly Evaporative Stress Index"

                    }


                    dispatch({
                      type: ON_MAP_CLICK,
                      chartData: {
                        seriesData: chartData,
                        // categories:chartDates,
                        title: `${title_pro}`,
                        yAxisTitle: yaxistitle,
                        xAxisTitle:"Month",
                        long: e.latlng.lng,
                        lat: e.latlng.lat,
                        // xAxisTitle:"Days",
                        name: menu,
                        type: "line",
                        curve:"smooth",
                        formatter:"MMM yyyy",

                        maximumDate: new Date(Math.max.apply(null, dates)),
                        minimumDate: new Date(Math.min.apply(null, dates)),
                      },
                      showInfo: true,
                      pointInfo: pointInfo,
                    });
                  }
            }
          } catch (e) {
            dispatch({
              type: GET_ET_ERROR,
              payload: console.log(e),
            });
          }
        }
      }
    }
    else
    {
      dispatch({
        type: TOGGLE_VISIBLE_GRAPH,
        visibleGraphPanel:false,
        latlng: e.latlng,
      });
    }

  }


  
  if(getState().ETState.selectedMenu === "et-Evapotranspiration-Fortnightly750"||getState().ETState.selectedMenu=== "pet-Evapotranspiration-Fortnightly750"||getState().ETState.selectedMenu=== "mai-Evapotranspiration-Fortnightly750"||getState().ETState.selectedMenu=== "esi-Evapotranspiration-Fortnightly750") {
    let result = await axios({
      method: "post",
      url: `${domain.DBServer}/get-pixel-boundary-status`,
      data: {
        lon: e.latlng.lng,
        lat: e.latlng.lat
        // selected: this.state.selectedMenu
      }
    });
  
    if (result) {
      if(result.data[0].bounds)
      {
        dispatch({
          type: FETCH_REQUEST,
          visibleGraphPanel: true,
          loading: true,
          chartData: null,
          latlng: e.latlng,
        });
        if (e.latlng) {
          let chartData;
          try {
            let result = await axios({
              method: "post",
              url: `${domain.DBServer}/get-pixel-value-${
                getState().ETState.selectedMenu
                }`,
              data: {
                lon: e.latlng.lng,
                lat: e.latlng.lat,
                // selected: getState().ETState.selectedMenu
              },
            });
            let pointInfo = null, fortnight;
            let activeDate = moment.isMoment(getState().ETState.date)
              ? getState().ETState.date.format("YYYYMMDD")
              : moment(getState().ETState.date, "DD-MM-YYYY").format("YYYYMMDD");
            if (result) {
              if (result.data) {
                var regex = /[0-9][0-9][0-9][0-9][0-9][0-9]/gi;
                let fullDate,chartData1, dates_final=[],values_final=[],fn1_dates=[],fn2_dates=[],fn1_values=[],fn2_values=[],lat,long;

                //console.log("result et fn selected",getState().ETState.fn_selectedLayer,result.data)
                chartData1 = result.data.map((item) => {                      
                            let yearMonth = item.filename.match(regex)[0];

                            if(item.filename.indexOf("FN1")!==-1)

                            {
                              fullDate=yearMonth+"01";
                              let  dateObject = moment(fullDate, 'YYYYMMDD').toDate();
                          let formattedDate = moment(dateObject).format('DD MMM YYYY');
                          const dayOfMonth = moment(dateObject).date();
                          const fortnightPrefix = dayOfMonth <= 14 ? 'FN1' : 'FN2';
                          formattedDate = formattedDate.replace(/^(\d+)/, fortnightPrefix);
                          fn1_dates.push(formattedDate)
                          fn1_values.push( item.pixel_val === 65535 || item.pixel_val === 65534|| item.pixel_val===null
                            ? null
                            : Number(item.pixel_val).toFixed(3))

                            }
                            if(item.filename.indexOf("FN2")!==-1)

                              {
                                fullDate=yearMonth+"15";
                                let  dateObject = moment(fullDate, 'YYYYMMDD').toDate();
                          let formattedDate = moment(dateObject).format('DD MMM YYYY');
                          const dayOfMonth = moment(dateObject).date();
                          const fortnightPrefix = dayOfMonth <= 14 ? 'FN1' : 'FN2';
                          formattedDate = formattedDate.replace(/^(\d+)/, fortnightPrefix);
                          fn2_dates.push(formattedDate)
                          fn2_values.push( item.pixel_val === 65535 || item.pixel_val === 65534 || item.pixel_val===null
                            ? null
                            : Number(item.pixel_val).toFixed(3))
                              }
                              return  [
                                new Date(
                                  moment(item.filename.match(regex)[0], "YYYYMM").format("MMM YYYY")
                                ).getTime(),
                                item.pixel_val === 65535 || item.pixel_val === 65534
                                  ? null
                                  : Number(item.pixel_val).toFixed(3),
                              ];
                        
                           
                          
                    });
                     
                    ////console.log("dates_final",chartData1,fn2_dates,fn1_dates)

                     //console.log("fn1_dates.lenght,fn1_dates.lenght,",fn1_dates.length,fn2_dates.length,fn1_dates,fn2_dates)
                      // 
                      
                      let max_length = Math.max(fn1_dates.length, fn2_dates.length);

                        for (let i = 0; i < max_length; i++) {
                            if (i < fn1_dates.length) {
                                dates_final.push(fn1_dates[i]);
                                values_final.push(fn1_values[i]);
                            }
                            if (i < fn2_dates.length) {
                                dates_final.push(fn2_dates[i]);
                                values_final.push(fn2_values[i]);
                            }
                        }

                      //console.log("dates_final",dates_final,values_final)

                       chartData1 = {};
                      dates_final.forEach((date, index) => {
                        chartData1[date] = values_final[index];
                      });
                  //console.log("dates_final chartdata1",chartData1,fn2_dates,fn1_dates)

                  const extractDate = (date) => {
                    //console.log("DDDDDDDDDDDDDDDDates extract ",date)
                    const [, month, year] = date.split(' ');
                    return new Date(`${month} 1, ${year}`);
                  }
                  
                  // Convert all dates to Date objects
                  const dateObjects = dates_final.map(date => extractDate(date));
                  //console.log("Resulting chart data with missing dates filled: yaxis",dateObjects)

                  // Find the minimum and maximum dates
                  const startDate = new Date(Math.min.apply(null, dateObjects));
                  const endDate = new Date(Math.max.apply(null, dateObjects));
                  //console.log("Resulting chart data with missing dates filled: yaxis",endDate)


                  function getDatesInRange(startDate,endDate) {
                    const dates = [];
                    //console.log("Resulting chart data with missing dates filled: yaxis899")

                    let currentDate = new Date(startDate);
                    while (currentDate <= endDate) {
                      dates.push(new Date(currentDate));
                      currentDate.setMonth(currentDate.getMonth() + 1); // Move to the next month
                    }
                    return dates;
                  }
                  
                  // Get all dates within the specified range
                  const allDatesInRange = getDatesInRange(startDate, endDate);
                  //console.log("datefinal alldates",allDatesInRange)
                  
                  // Convert dates to the desired format (e.g., "FN1 Dec 2020")
                  const formattedDates = allDatesInRange.flatMap(date => {
                    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                    const monthYear = monthNames[date.getMonth()] + ' ' + date.getFullYear();
                    return [
                        'FN1 ' + monthYear,
                        'FN2 ' + monthYear
                    ];
                });
                //console.log("formatted dates", formattedDates)
                  
                  // Initialize an empty chartData array
                  let chartData = [];
                  
                  // Iterate over formattedDates and add missing dates to chartData with null values
                  formattedDates.forEach(date => {
                    if (chartData1[date] === undefined) {
                      chartData.push([date, "NA"]);
                    } else {
                      chartData.push([date, chartData1[date]]);
                    }
                  });
                  
                  
                  // Sort chartData by date
                  chartData.sort((a, b) => {
                    const dateA = new Date(a[0]);
                    const dateB = new Date(b[0]);
                    return dateA - dateB;
                  });
                  
                  //console.log("Resulting chart data with missing dates filled:", chartData);
                    //fortnight=fortnight;
                    let menu =
                      getState().ETState.selectedMenu === "et-Evapotranspiration-Fortnightly750"|| "pet-Evapotranspiration-Fortnightly750"|| "mai-Evapotranspiration-Fortnightly750"|| "esi-Evapotranspiration-Fortnightly750" 
                        ? "Evapotranspiration-Fortnightly"
                        : getState().ETState.selectedMenu === "Evapotranspiration_WB"
                          ? "Evapotranspiration (WB)"
                          : null;
                    let title_pro=getState().ETState.selectedMenu.split("-")[0].toUpperCase()=="ET"?"AET": getState().ETState.selectedMenu.split("-")[0].toUpperCase()

                    let yaxistitle ;
                    if (getState().ETState.selectedMenu.split("-")[0].toUpperCase()==="ET" )
                      {
                        yaxistitle=`AET (mm/day)`
                        title_pro= "Fortnightly Actual Evapotranspiration"
                      }
  
                      if ( getState().ETState.selectedMenu.split("-")[0].toUpperCase()==="PET" ){
                        yaxistitle=`PET (mm/day)`
                        title_pro= "Fortnightly Potentional Evapotranspiration"
  
                      }
                      if (getState().ETState.selectedMenu.split("-")[0].toUpperCase()==="MAI" )
                      {
                        yaxistitle=`MAI (%)`
                        title_pro= "Fortnightly Moisture Adequacy Index"
  
                      }
                      if (getState().ETState.selectedMenu.split("-")[0].toUpperCase()==="ESI" )
                      {
                        yaxistitle=`ESI`
                        title_pro= "Fortnightly Evaporative Stress Index"
  
                      }
//console.log("Resulting chart data with missing dates filled: yaxis",yaxistitle, title_pro)
                    dispatch({
                      type: ON_MAP_CLICK,
                      chartData: {
                        seriesData: chartData,
                        // categories:chartDates,
                        title: `${title_pro}`,
                        yAxisTitle: yaxistitle,
                        xAxisTitle:"Fortnight",
                        long: e.latlng.lng,
                        lat: e.latlng.lat,
                        // xAxisTitle:"Days",
                        
                        name: menu,
                        type: "line",
                        curve:"smooth",
                        formatter:"MMM yyyy",
                       // fortnight:`${fortnight}`,

                        maximumDate: new Date(Math.max.apply(null, dates)),
                        minimumDate: new Date(Math.min.apply(null, dates)),
                      },
                      showInfo: true,
                      pointInfo: pointInfo,
                    });
                  
                  }
                
            }
          } catch (e) {
            dispatch({
              type: GET_ET_ERROR,
              payload: console.log(e),
            });
          }
        }
      }
    }
    else
    {
      dispatch({
        type: TOGGLE_VISIBLE_GRAPH,
        visibleGraphPanel:false,
        latlng: e.latlng,
      });
    }

  }
 
  
};
